import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';
import Ava36 from 'dc/Ava36';

export const Wrapper = styled.div`
  display: flex;
  background: transparent;
  height: 36px;
  align-items: center;
`;

export const Avatar = styled(Ava36)`
  vertical-align: middle;
`;

export const Composite = styled.div`
  flex: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  margin-left: 16px;
`;

export const Name = styled(Typ30)`
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
`;
